var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('HeaderSearch'),(_vm.isMobile === true)?_c('ScrollTop'):_vm._e(),_c('LoginTip',{attrs:{"dialogVisible":_vm.dialogVisible},on:{"hideDialog":_vm.hideDialog}}),(_vm.isMobile === false)?_c('Footer'):_vm._e(),(_vm.isMobile === true)?_c('Bottom',[_vm._v("123")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }